import React from 'react'
import ManpowerHero from './ManpowerHero'
import ManpowerContent from './ManpowerContent'
import ManpowerServices from './ManpowerServices'
import ManpowerSection from './Manpowersection'
import ManpowerTransform from './ManpowerTransform'
import Footer from '../../Footer/Footer'










function ManpowerCorporate() {
    return (
        <div>
            <ManpowerHero/>
            <ManpowerContent/>
            <ManpowerServices/>
            <ManpowerSection/>
            <ManpowerTransform/>
            <Footer/>
            
        </div>
    )
}

export default ManpowerCorporate
